<template>
    <div class="digitalToolProcess">
          <el-button type="primary" @click="isShowSearchCondition=true">查询</el-button>
          <el-form v-if="isShowSearchCondition" :inline="true" class="demo-form-inline">
              <el-row>
                <el-form-item label="流程名称">
                  <el-select
                      style="width: 130px;"
                      v-model="searchParams.processInstanceId"
                      filterable
                      remote
                      clearable
                      reserve-keyword
                      placeholder="请输入名称"
                      :remote-method="queryProcessList"
                      :loading="processNameLoading" 
                      @change="selectProcessNameTrigger">
                      <el-option
                          v-for="item in processList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="流程模板">
                    <el-select style="width: 125px;" filterable clearable v-model="searchParams.processServiceId" @change="handleSearch"  placeholder="请选择">
                        <el-option
                            v-for="item in processTemplateList"
                            :key="item.key"
                            :label="item.templateName"
                            :value="item.processServiceId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="role !== 'startedBy'" label="发起人">
                    <el-input title='流程发起人' readonly style="width: 80px;" v-model="selectedStartedUser.selectedUserNames" @focus="chooseProcessStartedUser" ></el-input>
                    <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowStartedUserOrg'  :selectedUser="selectedStartedUser" ref="startedUserOrgPop" @nodeClick="processStartedUserSelectTrigger" />
                </el-form-item>
                <el-form-item  v-if="role !== 'assignee'"  label="负责人">
                    <el-input :title='selectedProcessUser.selectedUserNames' readonly style="width: 80px;" v-model="selectedProcessUser.selectedUserNames" @focus="chooseProcessAssigneeUser" ></el-input>
                    <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowProcessUserOrg' :multiple='true' :selectedUser="selectedProcessUser" ref="processUserOrgPop" @nodeClick="processAssigneeSelectTrigger" />
                </el-form-item>
                <el-form-item label="子流程">
                    <el-select style="width: 100px;" @change="handleSearch" v-model="searchParams.hasSubProcess" placeholder="请选择">
                        <el-option
                            v-for="item in processInstanceTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select style="width: 90px;" @change="handleSearch" v-model="searchParams.state" placeholder="请选择">
                        <el-option
                            v-for="item in processStateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-row>
        </el-form>
         <el-table
            :height="tableHeight"
            :style="tableStyle"
            :data="instancesListTemp"
            row-key="id"
            :tree-props="{children: 'children'}"
            :border="true"
            v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="name" label="流程名称" :show-overflow-tooltip="true">
               <template slot-scope="scope">
                  【{{scope.row.started }}】{{scope.row.name }}
                  </template>
            </el-table-column>
            <el-table-column prop="processInstanceDurationTime" :show-overflow-tooltip="true" label="流程耗时" ></el-table-column>
            <!-- <el-table-column label="当前任务" :show-overflow-tooltip="true" >
                <template slot-scope="scope" >
                  <CurrentTasksColumn
                      v-if="!scope.row.finish" 
                      :isFromBusTab="false"
                      :isShowOverflowTooltip="true"
                      :cellValue="scope.row['templateName']"
                        :taskInstanceList="scope.row['currentTasks']"
                      :processInstanceId="scope.row['id']"
                      :processInstanceName="scope.row['name']"
                      :createdByName="scope.row['assigneeUserName']"
                      :createdDate="scope.row['started']"
                      :readOnly='true'
                  />
                  <el-tag v-if="scope.row.finish" type="primary" size="small">流程已完成</el-tag>
              </template>
            </el-table-column> -->
              <el-table-column
                  label="当前任务"
                  :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope" >
                      <AsynCurrentTasksColumn
                          v-if="!scope.row.finish"
                          :readOnly="true"
                          :columnRow="scope.row"
                          :closeFirstTaskCanDeleteBtn="true"
                          :isShowOverflowTooltip="true"
                          :cellValue="scope.row['templateName']"
                          :processInstanceId="scope.row['id']"
                          :processInstanceName="scope.row['name']"
                          :processInstanceStatus="scope.row['processInstanceStatus']"
                          :createdByName="scope.row['assigneeUserName']"
                          :createdDate="scope.row['started']"
                      />
                      <el-tag v-if="scope.row.finish" type="primary" size="small">流程已完成</el-tag>
                  </template>
                </el-table-column> 
            <!-- <el-table-column prop="started" label="发起时间" :sortable="true" width="140"></el-table-column> -->
            <el-table-column label="流程角色" >
              <template slot-scope="scope">
                <el-tag v-if="currentUserId===scope.row.startedBy.id" type="warning">我发起的</el-tag>
                <el-tag v-else type="info">我参与的</el-tag>
              </template>
            </el-table-column>
            
            <!-- <el-table-column   label="操作" width="265">
                <template slot-scope="scope">
                    <el-button size="mini" icon="el-icon-info" title="流程动态" circle @click="processRecordView(scope.row)"></el-button>
                    <el-button size="mini" icon="el-icon-setting" title="详情设置" circle @click="handleViewProcessDetail(scope.row)"></el-button>
                    <el-button size="mini" title='流程图' circle icon="el-icon-picture-outline" @click="handelShowDiagram(scope.row)"></el-button>
                    <el-button v-if="scope.row.hasSubProcess==='1'" size="mini" icon="el-icon-s-grid" title="主子流程关系图" circle @click="handelShowProcessRelate(scope.row)"></el-button>
                    <el-button size="mini" v-if="scope.row.hasReports" title='业务树关系图' circle icon="el-icon-connection" @click="handelShowReportRelateTree(scope.row)"></el-button>
                    <el-button size="mini" v-if="scope.row.hasReports && scope.row.reportsCnt===1" title="百川金字塔" class="iconfont icon-other-liucheng"  circle @click="handleShowOrgTreeView(scope.row)"></el-button>
                    <el-button size="mini" type="danger" v-if="scope.row.canCancelProcess" title='删除' circle icon="el-icon-delete" @click="handleCancelProcessInstances(scope.row)"></el-button>
                </template>
            </el-table-column> -->
        </el-table>
    </div>
</template>

<script>
    import { clone, isEmpty } from 'lodash';
    import { getProcessTimeTreeList, getProcessInstancesList, getProcessInstancesDetail, cancelProcessInstance, getAllUserTask, getArchiveTemplateTreeList, getProcessTemplateList, getModelFormReportOrgTree, getModelFormReportTree } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import ProcessRelateTree from '@/components/ProcessRelateTree';
    import ProcessAdjList from '@/components/ProcessAdjList';
    import ProcessReportList from '@/pages/process/MyProcess/ProcessReportList';
    import CurrentTasksColumn from '@/pages/process/MyProcess/CurrentTasksColumn';
    import AsynCurrentTasksColumn from '@/pages/process/MyProcess/AsynCurrentTasksColumn';
    export default {
        mixins: [ mixinsNav ],
        components: {
            ProcessRelateTree,
            ProcessAdjList,
            ProcessReportList,
            CurrentTasksColumn,
            AsynCurrentTasksColumn
        },
        data () {
            return {
                vueOrgTreeLoadTimer: '',
                treeOrgData: {},
                isShowOrgTreeDialog: false,
                isShowProcessListDialog: false,
                processStartedBy: '', // 默认全部1我发起2我参与
                processStartedByList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: '1',
                        label: '我发起'
                    }, {
                        value: '2',
                        label: '我参与'
                    }],
                currentCnt: 0,
                instancesListTempCnt: 0,
                instancesListTemp: [], // 临时列表
                instancesList: [], // 列表数据
                loading: false, // 列表的loading状态
                searchKeyWord: '', // 查询的关键字,
                processInstanceId: '', // 流程实例ID
                instancesInfo: {},
                isFinish: false,
                isCancel: false,
                isShowProcessDetail: false,
                isShowProcessDetailDrawer: false,
                direction: 'rtl',
                isShowDiagram: false,
                taskList: [],
                archiveTemplateTreeList: [],
                isShowSetting: false,
                isReloadProcess: false,
                loadTimer: '',
                currentUserId: '',
                currentUserName: '',
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 100000, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                currentProcessInstanceId: '',
                isShowProcessRelate: false,
                isShowReportRelateTree: false,
                processReportList: [], // 当前流程绑定的报表
                searchParams: {
                    pageSize: 100000,
                    currentPage: 1,
                    processServiceId: '', // 流程模板对应的方案ID
                    startedByUserId: '', // 流程发起人ID
                    assigneeUserId: '', // 流程负责人Id
                    // fromBI: true,
                    hasSubProcess: '', // 默认全部
                    isTree: true, // 树列表结构
                    allProcessInstance: true, // 查询所有流程实例
                    processStartedBy: '', // 默认全部1我发起2我参与
                    serviceName: '',
                    state: this.processState ? this.processState : '' // 流程状态 ：默认 全部
                },
                isShowNewMode: true, // 查询形式 false: 旧版 true：新版
                selectedStartedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowStartedUserOrg: false,
                selectedProcessUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                isShowProcessUserOrg: false,
                processTemplateList: [],
                processStateList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: 1,
                        label: '进行中'
                    }, {
                        value: 2,
                        label: '已完成'
                    }, {
                        value: 4,
                        label: '已终止'
                    }],
                processInstanceTypeList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: '0',
                        label: '不含子流程'
                    }, {
                        value: '1',
                        label: '含子流程'
                    }],
                isShowPreview: false,
                processList: [],
                processNameLoading: false,
                isShowSearchCondition: false
            };
        },
        props: {
            processState: {// 默认进行中
                type: [String, Number],
                default: 1 // 流程状态 ：默认 进行中
            },
            tableHeight: {
                type: Number,
                default: 260
            },
            tableStyle: {
                type: String,
                default: 'width: 100%;'
            },
            taskInfo: {
                type: Object
            },
            hideModeSwich: {
                type: Boolean,
                default: false
            },
            role: {
                type: String,
                default: ''
            },
            isFromBusTab: {
                type: Boolean,
                default: false
            },
            isListView: {// 我的流程列表模式：true 块模式 false
                type: Boolean,
                default: false
            }
        },
        created () {
            this._initPage();
            // console.log(this.isShowNewMode);
            let currentUserStr = sessionStorage.getItem('currentUserInfo');
            if (currentUserStr) {
                let currentUserInfo = JSON.parse(currentUserStr);
                this.currentUserId = currentUserInfo.userId;
                this.currentUserName = currentUserInfo.trueName;
            }
        },
        methods: {
            async _initPage () {
                this.isShowProcessDetail = false;
                this.isShowProcessDetailDrawer = false;
                this._getFormData();
            },
            async _getFormData () {
                this.loading = true;
                // let tempLoading = this.$loading({
                //     lock: true,
                //     text: 'Loading',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });
                let params = {
                    pageSize: 1000,
                    currentPage: 1,
                    serviceName: this.searchKeyWord,
                    state: this.processState,
                    processStartedBy: this.processStartedBy
                };
                if (!isEmpty(this.role)) {
                    let tempProcessStartedBy = '';
                    // console.log(this.role);
                    if (this.role === 'startedBy') {
                        tempProcessStartedBy = '1';
                    } else if (this.role === 'participant') {
                        tempProcessStartedBy = '2';
                    } else if (this.role === 'assignee') {
                        this.selectedProcessUser = {
                            selectedUserIds: this.currentUserId,
                            selectedUserNames: this.currentUserName
                        };
                        this.searchParams.assigneeUserId = this.selectedProcessUser.selectedUserIds;
                    };
                    params.processStartedBy = tempProcessStartedBy;
                    this.searchParams.processStartedBy = tempProcessStartedBy;
                    this.processStartedBy = tempProcessStartedBy;
                }
                if (this.taskInfo) {
                    params.relationProcessInstanceId = this.taskInfo.processInstanceId;
                    params.relationTaskInstanceId = this.taskInfo.id;
                }
                // 新版本列表展示流程实例
                this.searchParams.isSearchNowTasks = false;// 否查询当前所在任务节点信息

                let formData = await getProcessTimeTreeList(Object.assign({}, {
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                }, this.searchParams));

                if (formData) {
                    this.instancesList = formData.data;
                    if (!this.isShowNewMode) {
                        this.page.totalPageNum = this.instancesList.length;
                    } else {
                        this.page.totalPageNum = formData.totalPageNum;
                    }
                    this.dealData();
                    await this.initProcessTemplateList();
                }
                // tempLoading.close();
                this.queryProcessList('');
                this.loading = false;
            },
            handleSearch () {
                this._getFormData();
            },
            queryTableData (currentPage) {
                this.page.currentPage = currentPage;
                this.dealData();
            },
            async  handleViewProcessDetail (row) {
                const tempLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.instancesInfo = await getProcessInstancesDetail(row.id);
                tempLoading.close();
                this.isCancel = false;
                this.loadTimer = new Date().getTime();
                if (this.isShowNewMode) {
                    this.isShowProcessDetailDrawer = true;
                } else {
                    this.isShowProcessDetail = true;
                }
            },
            handleModeSwitch () {
                this.$emit('handleModeSwitch', 'block');
            },
            async reloadProcess (processInstanceId, isUpdName) {
                this.isShowProcessDetail = false;
                this._initPage();
            },
            async handleCancelProcessInstances (instances) {
                let tempLoading = '';
                this.$confirm(`您确定要删除流程[ ${instances.name} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    tempLoading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await cancelProcessInstance(instances.id);
                    tempLoading.close();
                    // this.reloadProcess();
                    this._initPage();
                }).catch(() => {
                    tempLoading.close();
                });
            },
            async handelShowDiagram (instances) {
                // console.log(instances);
                this.instancesInfo = instances;
                await this.setProcessViewInfo(instances);
                this.loadTimer = new Date().getTime();
                this.isShowDiagram = true;
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.processDiagrams.setProcessState(this.isFinish);
                    this.$refs.processDiagrams.resetDiagramUrl();
                }, 0);
            },
            async handelProcessDetail (isReloadProcess) {
                await this.setProcessViewInfo(this.instancesInfo);
                this.isShowSetting = true;
                this.isReloadProcess = isReloadProcess;
            },
            async setProcessViewInfo (instances) {
                const tempLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let tasks = await getAllUserTask(instances.id, instances.processServiceId, null, instances.deploymentId);
                this.taskList = tasks;
                let treeList = [];
                if (instances.archiveTemplateId) {
                    treeList = await getArchiveTemplateTreeList({templateId: instances.archiveTemplateId});
                }
                this.archiveTemplateTreeList = treeList;
                tempLoading.close();
            },
            cancelProcessSetting () {
                if (this.isReloadProcess) {
                }
                this.isShowSetting = false;
            },
            closeProcessSetting () {
                if (!this.isCancel) {
                    if (this.isReloadProcess) {

                    }
                    this.isShowSetting = false;
                }
            },
            loadMore () {
                // this.$message.success('加载下一页');
                this.currentCnt = this.instancesList.length;
                // console.log(this.currentCnt);
                if (this.currentCnt < this.instancesListTempCnt) {
                    let item = clone(this.instancesListTemp[this.currentCnt]);
                    // console.log(item);
                    this.instancesList.push(item);
                }
            },
            handleSizeChange (val) {
                this.page.pageSize = val;
                this.dealData();
            },
            dealData () {
            // 分页操作，每次取当前页*每页显示的条数再加每页显示的条数
                let cpage = (this.page.currentPage - 1) * this.page.pageSize;
                let count = this.page.pageSize + cpage;
                if (this.instancesList && this.instancesList.length > 0) {
                    this.instancesListTemp = this.instancesList.slice(cpage, count);
                } else {
                    this.instancesListTemp = [];
                }
            },
            async handelShowProcessRelate (row) {
                this.loadTimer = new Date().getTime();
                this.currentProcessInstanceId = row.id;
                setTimeout(() => {
                    this.$refs.processRelateTree._initPage();
                }, 0);
                this.isShowProcessRelate = true;
            },
            async handelShowReportRelateTree (item) {
                this.loadTimer = new Date().getTime();
                // this.processReportList = item.reports;
                let instancesInfo = await getProcessInstancesDetail(item.id);
                this.processReportList = instancesInfo.reports;
                setTimeout(() => {
                    this.$refs.reportRelateTree._initPage();
                }, 0);
                this.isShowReportRelateTree = true;
            },
            chooseProcessAssigneeUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.processUserOrgPop._initPage();
                }, 0);
                this.isShowProcessUserOrg = true;
            },
            processAssigneeSelectTrigger (selected) { // 流程负责人
                this.selectedProcessUser = selected;
                this.searchParams.assigneeUserId = selected.selectedUserIds;
                this.handleSearch();
                this.loadTimer = new Date().getTime();
            },
            chooseProcessStartedUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.startedUserOrgPop._initPage();
                }, 0);
                this.isShowStartedUserOrg = true;
            },
            processStartedUserSelectTrigger (selected) { // 流程发起人
                this.selectedStartedUser = selected;
                this.searchParams.startedByUserId = selected.selectedUserIds;
                this.handleSearch();
                this.loadTimer = new Date().getTime();
            },
            async initProcessTemplateList () {
                let latestData = await getProcessTemplateList({ state: 1, currentPage: 0, pageSize: 500 });// 查出最新版本的流程方案
                if (latestData) {
                    this.processTemplateList = latestData.data;
                }
            },
            async processRecordView (row) {
                this.loadTimer = new Date().getTime();
                this.instancesInfo = row;
                this.currentProcessInstanceId = this.instancesInfo.id;
                // console.log("当前流程实例ID"+this.currentProcessInstanceId);
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.processAdjList._initPage();
                }, 0);
                this.isShowPreview = true;
            },
            handleStartProcess () {
                this.$emit('handleTemplateSwitch', true);
            },
            chooseProcess () {
                this.isShowProcessListDialog = true;
            },
            selectTrigger (selected) { // 选择流程
                this.searchParams.serviceName = selected.label;
            },
            selectProcessNameTrigger (id) { // 选择流程
                let selected = {id: '', label: ''};
                if (id) {
                    selected = this.processList.find((item) => {
                        return item.id === id;
                    });
                }
                this.searchParams.serviceName = selected.name;
                this.handleSearch();
            },
            async handleClickOk () {
                this.isShowProcessListDialog = false;
                // 选完流程后自动查询
                this.handleSearch();
            },
            navToBusiniessTaskTab () {
                this.$emit('navToBusiniessTaskTab');
                this.isShowProcessDetailDrawer = false;
            },
            async queryProcessList (name) {
                this.processNameLoading = true;
                let processInstances = await getProcessInstancesList({
                    pageSize: 1000,
                    currentPage: 1,
                    serviceName: name,
                    state: this.processState
                });
                if (processInstances && processInstances.data) {
                    this.processList = processInstances.data;
                }
    
                this.processNameLoading = false;
            },

            async handleShowOrgTreeView (row) {
                const tempLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                setTimeout(async () => {
                    let instancesInfo = await getProcessInstancesDetail(row.id);

                    let searchParams = {
                        isAllData: false,
                        modelId: '',
                        name: '',
                        selectedFields: '',
                        searchCondition: [],
                        selectedApprovalStatus: ''
                    };
                    searchParams.modelId = instancesInfo.reports[0].modelId;
                    searchParams.formId = instancesInfo.reports[0].formId;
                    searchParams.isFilterDuplicateData = true;
                    searchParams.processInstanceId = row.id;
                    let formData = await getModelFormReportTree(Object.assign({}, {
                        currentPage: 1,
                        pageSize: 10
                    }, searchParams));
                    let treeData = [];
                    if (formData.data) {
                        let tableDatas = [];
                        formData.data.forEach(item => {
                            let jsonObj = JSON.parse(item);
                            tableDatas.push(jsonObj);
                        });
                        treeData = tableDatas;
                    }
                    if (treeData && treeData.length > 0) {
                        let formData = await getModelFormReportOrgTree(instancesInfo.reports[0].formId, treeData[0].id);
                        this.treeOrgData = {};
                        if (formData.data) {
                            let tableDatas = {};
                            formData.data.forEach(item => {
                                tableDatas = JSON.parse(item);
                            });
                            this.treeOrgData = tableDatas;
                        }
                        this.isShowOrgTreeDialog = true;
                    } else {
                        this.$message({ message: '暂时没有数据', type: 'warning', uration: 3000 });
                    }
                    tempLoading.close();
                }, 0);
            },
            navToMyTaskMyAssignee () {
                this.navMyTaskMyAssignee();// 我负责
            }
        }
    };
</script>

<style lang="less">
    .digitalToolProcess {
        height: 100%;
        width: 100%;
        margin-top: -14px;
        .table-main {
            // height:540px;
            overflow-y:auto;
        }
    }
    // .business-report-tree{
    //     .process-report-dialog{
    //         .el-dialog__body{
    //             height: ~'calc(100% - 10vh)';
    //             margin-top: -2vh;
    //             padding: 20px 20px;
    //         }
    //     }
    // }
</style>



// WEBPACK FOOTER //
// src/components/DigitalTool/DigitalToolProcess.vue